// extracted by mini-css-extract-plugin
export default {"container":"authPage_container__Uqdb3","header":"authPage_header__MqdUr","footer":"authPage_footer__wzDQ+"};